import authReducer from "./authReducer";
import configReducer from "./configReducer";
import extraReducer from "./extraReducer";

let reducerCombined = {
  auth: authReducer,
  config: configReducer,
  extra: extraReducer,
};

export default reducerCombined;
